import { Pipe, PipeTransform } from '@angular/core';

/**
 * Resolves an entity by id out of an already-fetched list - for pre-seeding a lookup widget's
 * display (e.g. abp-lookup-typeahead's [editingData]) from a URL-hydrated filter id, without a
 * getter per field.
 */
@Pipe({
  name: 'findById'
})
export class FindByIdPipe implements PipeTransform {
  transform<T extends { id?: string }>(items: T[] | null | undefined, id: string | null | undefined): T | undefined {
    if (!items || !id) return undefined;
    return items.find(item => item.id === id);
  }
}
